<template>
    <div>
        <b-modal v-model="mostrarModal" @show="iniciarForm()">
            <div slot="modal-title">Relação das Contratações e Entregas</div>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Unidade das Contratações</label>
                        <b-form-select
                            :plain="true"
                            :options="unidades"
                            text-field="unidade"
                            value-field="codUnidade"
                            v-model="unidade"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="perfil != 'gestor'">
                <b-col sm="12">
                    <b-form-group>
                        <label>Gestor das Contratações</label>
                        <b-form-select
                            :plain="true"
                            :options="gestores"
                            text-field="gestor"
                            value-field="codGestor"
                            v-model="gestor"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label>Início das Contratações (DE)</label>
                        <date-picker
                            v-model="dataInicioDe"
                            :config="$datePickerOptions2"
                            v-mask="'##/##/####'"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label>Início das Contratações (ATÉ)</label>
                        <date-picker
                            v-model="dataInicioAte"
                            :config="$datePickerOptions2"
                            v-mask="'##/##/####'"
                        ></date-picker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label>Término das Contratações (DE)</label>
                        <date-picker
                            v-model="dataTerminoDe"
                            :config="$datePickerOptions2"
                            v-mask="'##/##/####'"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label>Término das Contratações (ATÉ)</label>
                        <date-picker
                            v-model="dataTerminoAte"
                            :config="$datePickerOptions2"
                            v-mask="'##/##/####'"
                        ></date-picker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Situação das Contratações</label>
                        <b-form-select
                            :plain="true"
                            :options="situacoes"
                            text-field="situacaoDescr"
                            value-field="situacao"
                            v-model="situacao"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Status das Entregas</label>
                        <b-form-select
                            :plain="true"
                            :options="statusOpc"
                            text-field="statusDescr"
                            value-field="status"
                            v-model="status"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label>Previsão das Entregas (DE)</label>
                        <date-picker
                            v-model="dataPrevisaoDe"
                            :config="$datePickerOptions2"
                            v-mask="'##/##/####'"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label>Previsão das Entregas (ATÉ)</label>
                        <date-picker
                            v-model="dataPrevisaoAte"
                            :config="$datePickerOptions2"
                            v-mask="'##/##/####'"
                        ></date-picker>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fechar()"
                    class="mr-2"
                    >Cancelar</b-button
                >
                <b-button variant="primary" @click.stop="filtrar()"
                    >Emitir Relatório</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: {
        servicos: {
            type: Object
        },

        perfil: {
            type: String
        }
    },

    data() {
        return {
            mostrarModal: false,
            unidades: [],
            unidade: -1,
            gestores: [],
            gestor: -1,
            situacoes: [],
            situacao: -1,
            statusOpc: [],
            status: -1,
            dataInicioDe: null,
            dataInicioAte: null,
            dataTerminoDe: null,
            dataTerminoAte: null,
            dataPrevisaoDe: null,
            dataPrevisaoAte: null
        }
    },

    methods: {
        iniciarForm() {
            this.$store.dispatch('addRequest')
            this.servicos.obterOpcoesFiltro().then((response) => {
                if (response) {
                    if (response.success) {
                        this.unidades = response.data.unidades
                        this.unidades.unshift({
                            codUnidade: -1,
                            unidade: 'TODAS'
                        })
                        if (this.perfil != 'gestor') {
                            this.gestores = response.data.gestores
                            this.gestores.unshift({
                                codGestor: -1,
                                gestor: 'TODOS'
                            })
                        }
                        this.situacoes = response.data.situacoes
                        this.situacoes.unshift({
                            situacao: -1,
                            situacaoDescr: 'TODAS'
                        })
                        this.statusOpc = response.data.statusOpc
                        this.statusOpc.unshift({
                            status: -1,
                            statusDescr: 'TODOS'
                        })
                    } else {
                        this.$toast.error(
                            'Erro ao obter opções dos filtros',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        abrir() {
            this.mostrarModal = true
        },

        fechar() {
            this.mostrarModal = false
        },

        filtrar() {
            let filtroDto = {}
            if (this.unidade != -1) {
                filtroDto.unidade = this.unidade
            }

            if (this.gestor != -1 && this.perfil != 'gestor') {
                filtroDto.gestor = this.gestor
            }

            if (this.dataInicioDe) {
                filtroDto.dataInicioDe = this.$moment(
                    this.dataInicioDe,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD')
            }

            if (this.dataInicioAte) {
                filtroDto.dataInicioAte = this.$moment(
                    this.dataInicioAte,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD')
            }

            if (this.dataTerminoDe) {
                filtroDto.dataTerminoDe = this.$moment(
                    this.dataTerminoDe,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD')
            }

            if (this.dataTerminoAte) {
                filtroDto.dataTerminoAte = this.$moment(
                    this.dataTerminoAte,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD')
            }

            filtroDto.situacao = this.situacao

            filtroDto.status = this.status

            if (this.dataPrevisaoDe) {
                filtroDto.dataPrevisaoDe = this.$moment(
                    this.dataPrevisaoDe,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD')
            }

            if (this.dataPrevisaoAte) {
                filtroDto.dataPrevisaoAte = this.$moment(
                    this.dataPrevisaoAte,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD')
            }

            this.$emit('filtrar', filtroDto)
        }
    }
}
</script>
